<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar color="navbar">
        <ion-buttons slot="start">
          <ion-button @click="closeDetails">Close</ion-button>
        </ion-buttons>
        <ion-title>{{ entry.user }} ({{ entry.created | moment("from", "now") }})</ion-title>
        <ion-buttons slot="end">
          <ion-button @click="copyEntry">
            <ion-icon ios="ios-copy" md="md-copy"></ion-icon>
          </ion-button>
          <ion-button @click="emailEntry">
            <ion-icon ios="ios-mail" md="md-mail"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list>
        <ion-item @click="() => showValue(value)" :detail="value.type == 'email' || value.type == 'phone'" :tappable="value.type == 'email' || value.type == 'phone'" v-for="(value, index) in entry.values" v-bind:key="index">
          <ion-icon color="tertiary" :ios="'ios-' + value.icon" :md="'md-' + value.icon" slot="start"></ion-icon>
          <ion-label text-wrap color="primary">{{ value.title }}</ion-label>
          <ion-label text-wrap slot="end" color="dark">{{ value.value }}</ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  </div>
</template>

<script>
import Helpers from "../mixins/Helpers";
import Plugins from "../mixins/Plugins";
export default {
  name: "entry-details",
  mixins: [Helpers, Plugins],
  props: ["entry"],
  methods: {
    goBack: function() {
      this.hidePage();
    },
    closeDetails() {
      this.hideModal();
    },
    showValue(value) {
      if (value.type == "phone") {
        this.openPhone(value.value);
      } else if (value.type == "email") {
        this.openEmail(value.value);
      }
    },
    async copyEntry() {
      let contents = [];
      contents.push(`Form: ${this.entry.title}`);
      contents.push(`User: ${this.entry.user}`);
      contents.push(`Date: ${this.entry.created}`);
      for (let value of this.entry.values) {
        contents.push(`${value.title}: ${value.value}`);
      }
      this.copyClipboard(contents.join("\r\n"));
      this.showToast("Entry copied to the clipboard");
    },
    emailEntry() {
      let title = `${this.entry.title} - ${this.entry.user} (${this.entry.created})`;
      let body = [];
      for (let value of this.entry.values) {
        body.push(`${value.title}: ${value.value}`);
      }
      this.shareContent(title, body.join("\r\n"), this.entry.title);
    }
  }
};
</script>

<style scoped></style>
